import React from 'react';

import { Grid } from '@mui/material';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { COLOR_BACKGROUND_2 } from 'src/colors';

const ViewportContainer = ({ children, bgColor }: { children: any; bgColor?: string }) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down(900));

  return (
    <Grid
      container
      xs
      sx={{
        background: bgColor ? bgColor : COLOR_BACKGROUND_2,
        padding: '20px',
        pt: matches ? '20px' : '40px',
        height: '100vh',
      }}
      rowSpacing={2}
    >
      {children}
    </Grid>
  );
};

export default ViewportContainer;
